export const chipTheme = {
  root: {
    paddingX: '8px',
    paddingY: '4px',
    gap: '8px',
    borderRadius: '8px'
  },
  color: '{sd.text.primary}'
};
